import { CommonState, ListParams, Pagination } from './common';
import { ImageFields, Images } from './photo';

export enum DietTypes {
  DIET = 1,
  PDF = 2,
}

export const DietTypeLabels = {
  [DietTypes.DIET]: 'Карточка',
  [DietTypes.PDF]: 'PDF пособие',
};

export type DietLinks = {
  pdf_link: string;
  google_drive: string;
  yandex_disk: string;
};

export interface DietImages extends Images {
  [ImageFields.COVER]: string | null;
  [ImageFields.COVER_MOBILE]: string | null;
  [ImageFields.COVER_DESKTOP]: string | null;
}

export type Diet = {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  guaranties: string[];
  type: DietTypes;
  links: DietLinks;
  active: boolean;
  sort: number;
  images: DietImages;
  calories: number;
  description_title: string;
  guaranty_title: string;
  public: boolean;
};

export type DietList = {
  data?: Diet[];
  meta?: Pagination;
};

export type DietListParams = ListParams & {
  type: DietTypes;
};

export type DietState = CommonState & {
  dietList: DietList;
  dietListParams: DietListParams;
  diet?: Diet | null;
};

export type DietCreateForm = Omit<Diet, 'id'>;
export type ParamMassDietSort = { id: number; sort: number | null };
